import { DEFAULT_MAX_DATE, Deal, isValidDate, memoize } from '@jucy-ui/common';
import { addDays, min } from 'date-fns';
import { roundTime } from './roundTime';

export const getMaxDate = memoize(({ deal, pickUpDate }: { deal?: Deal; pickUpDate?: Date } = {}) => {
    const dealEnd = deal?.conditions?.endDateOnOrBefore || deal?.conditions?.endDateBetween?.from;
    const dealMaxHireDaysDate = deal?.conditions?.maxHireDays && pickUpDate ? addDays(pickUpDate, deal.conditions.maxHireDays) : undefined;
    return roundTime(min([dealMaxHireDaysDate, dealEnd, DEFAULT_MAX_DATE].filter((date) => isValidDate(date))));
});
